import React, { useState } from 'react';
import { LogOut } from 'lucide-react';
 
const LogoutButton = ({handleLogout}) => {
  const [isHovered, setIsHovered] = useState(false);
 
  const styles = {
    button: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '8px 16px',
      backgroundColor: isHovered ? '#ee3642' : '#ee3641',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
      boxShadow: isHovered 
        ? '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
        : 'none',
      outline: 'none',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      fontSize: '14px',
      fontWeight: '500',
      opacity: '0.9',
    },
  };
 
  // Focus styles
  const handleFocus = (e) => {
    e.target.style.boxShadow = '0 0 0 2px rgba(239, 68, 68, 0.5)';
  };
 
  const handleBlur = (e) => {
    e.target.style.boxShadow = isHovered 
      ? '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
      : 'none';
  };
 
  return (
<button
      style={styles.button}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={handleFocus}
      onBlur={handleBlur}
      onClick={handleLogout}
>
<LogOut 
        style={styles.icon}
        size={20}
      />
<span>Logout</span>
</button>
  );
};
 
export default LogoutButton;